import { defineComponent as r, createBlock as a, openBlock as l, unref as p, mergeProps as c, withCtx as i, createElementVNode as o } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconPriceTag",
  __name: "IconPriceTag",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (d, e) => (l(), a(p(m), c(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        o("path", { d: "M8.143 8.143A1 1 0 1 1 6.73 6.73a1 1 0 0 1 1.414 1.414" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M4.472 3.222a1.25 1.25 0 0 0-1.25 1.25v6.364a1.25 1.25 0 0 0 .366.884l8.692 8.692a1.25 1.25 0 0 0 1.768 0l6.364-6.364a1.25 1.25 0 0 0 0-1.768L11.72 3.588a1.25 1.25 0 0 0-.884-.366H4.472m.25 7.51v-6.01h6.01l8.443 8.442-6.01 6.01-8.443-8.442",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
